import { t } from "i18next";
import type { FC } from "react";
import { Trans } from "react-i18next";

import { EligibilityType } from "@utils/stake-input-types";
import { Button } from "tw/components/atoms/Button";

const getTexts = (isLockedStakeAccount: boolean) => {
  if (isLockedStakeAccount) {
    return [
      "app.unstaking.delayed.confirm-notice.deactivate-text.0",
      "app.unstaking.delayed.confirm-notice.deactivate-text.1",
    ];
  }

  return [
    "app.unstaking.delayed.confirm-notice.text.0",
    "app.unstaking.delayed.confirm-notice.text.1",
  ];
};

export interface DelayedUnstakeNoticeBodyProps {
  endDateAndTime: string;
  runUnstake: () => void;
  eligibilityType?: EligibilityType;
}

export const DelayedUnstakeNoticeBody: FC<DelayedUnstakeNoticeBodyProps> = ({
  endDateAndTime,
  runUnstake,
  eligibilityType,
}) => {
  const isLockedStakeAccount = eligibilityType === EligibilityType.Locked;
  return (
    <div className="w-full flex flex-col gap-4 md:pb-4">
      {getTexts(isLockedStakeAccount).map((text) => (
        <div key={text} className="flex gap-3 items-start">
          <div className="w-2 min-w-[8px] h-2 mt-2.5 rounded-full bg-primary" />
          <div>
            <Trans
              i18nKey={text}
              values={{ end: endDateAndTime }}
              components={[
                <span className="bg-page-bg"> </span>,
                <span className="bg-page-bg"> </span>,
              ]}
            />
          </div>
        </div>
      ))}
      <Button
        variant="primary"
        label={t("app.unstaking.delayed.confirm-notice.button") ?? ""}
        className="w-full"
        onClick={runUnstake}
      />
    </div>
  );
};
